<template>
  <header class="topbar sticky top-0 z-30">
    <div class="flex h-20 items-center justify-between px-4 sm:px-6 lg:px-8">
      <button class="mobile-menu-button" type="button" aria-label="Abrir menu" @click="$emit('toggle-menu')">
        <AppIcon name="menu" />
      </button>

      <div class="header-context hidden sm:block">
        <div class="text-xs font-semibold uppercase tracking-widest text-blue-200">{{ title }}</div>
        <div class="mt-1 text-sm text-white/80">{{ subtitle }}</div>
      </div>

      <div class="flex items-center gap-3">
        <!-- <button class="topbar-icon" type="button" title="Notificações" aria-label="Notificações">
          <AppIcon name="bell" />
          <span class="notification-dot" />
        </button> -->
        <div class="user-menu-wrap">
          <button class="user-menu-button" type="button" :aria-expanded="userMenuOpen" @click="userMenuOpen = !userMenuOpen">
            <span class="user-initials">{{ initials }}</span>
            <span class="hidden sm:block text-left">
              <span class="block text-sm font-semibold">{{ userName }}</span>
              <span class="block text-xs text-blue-200">Administrador</span>
            </span>
            <AppIcon name="chevronDown" class="hidden sm:block h-4 w-4 text-blue-200" />
          </button>
          <div v-if="userMenuOpen" class="user-dropdown">
            <div class="user-dropdown-name">{{ userName }}</div>
            <div class="user-dropdown-role">Administrador</div>
            <button type="button" @click="$emit('logout')">
              <AppIcon name="logout" /> Sair do sistema
            </button>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import AppIcon from './AppIcon.vue'

export default {
  name: 'AppHeader',
  components: { AppIcon },
  props: {
    userName: { type: String, default: 'Usuário' },
    title: { type: String, default: 'Sistema Financeiro' },
    subtitle: { type: String, default: 'GarantePay' }
  },
  emits: ['toggle-menu', 'logout'],
  data: () => ({ userMenuOpen: false }),
  computed: {
    initials () {
      const parts = this.userName.trim().split(/\s+/).filter(Boolean)
      return (parts.length > 1 ? `${parts[0][0]}${parts[parts.length - 1][0]}` : parts[0]?.slice(0, 2) || 'US').toUpperCase()
    }
  },
  watch: {
    '$route.fullPath' () {
      this.userMenuOpen = false
    }
  }
}
</script>
